import { PropertyAPI } from "@griffingroupglobal/eslib-api";
import { useMutation, useQueryClient } from "react-query";
import propertyKeys from "./propertiesKeys";

const deleteProperty = (properties) => {
  return Array.isArray(properties)
    ? PropertyAPI.postWOP("$bulkdelete", { properties })
    : PropertyAPI.delete(properties);
};

const usePropertiesDelete = () => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: deleteProperty,
    onMutate: async (id) => {
      const queryKey = propertyKeys.all;
      const properties = Array.isArray(id) ? id : [id];

      // Get the current state of the property to rollback in case of any error
      const currentProperties = queryClient.getQueryData(queryKey) || [];

      // Cancel any query for properties in the meantime
      await queryClient.cancelQueries(queryKey);

      // Find the property to delete by Id
      queryClient.setQueryData(queryKey, (current) =>
        current.filter((property) => !properties.includes(property.id))
      );

      return { currentProperties };
    },
    onError: (error, _, context) => {
      // Rollback to previous state
      const { queryKey, currentProperties } = context;
      queryClient.setQueryData(queryKey, currentProperties);

      console.error("usePropertiesDelete: ", error);
    },
    onSettled: () => {
      queryClient.invalidateQueries({
        queryKey: propertyKeys.all,
        exact: true,
      });

      queryClient.invalidateQueries({
        queryKey: propertyKeys.overview(),
        exact: true,
      });
    },
  });
};

export default usePropertiesDelete;
